







import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Results } from "@/types/NewResults.ts";

@Component
export default class LearnerTranscript extends Vue {
  @Prop() private activemetric!: string;
  @Prop() private results!: Results;
  private spanElTemplate: HTMLElement = document.createElement("span");

  private mounted() {
    this.onResults();
  }

  @Watch("activemetric")
  private onMetricChanged() {
    this.onResults();
  }

  @Watch("results")
  private onResults() {
    const appendSlicedText = (
      wordArray: string[],
      el: HTMLElement,
      start: number,
      end: number
    ) => {
      let beforeSpace = "";
      if (start === 0) {
        beforeSpace = "";
      }
      const text = wordArray.slice(start, end);
      const textNode = document.createTextNode(
        beforeSpace + text
      );
      el.appendChild(textNode);
    };

    const transcriptTextEl = this.$refs.transcriptText as HTMLElement;
    transcriptTextEl.innerHTML = "";
    let textStart = 0;
    var transcript = this.results.transcript;
    const wordArray = transcript.split("");
    let index = 0;
    for (index = 0; index < wordArray.length; index++) {
      const word = wordArray[index];
      const wordNode = document.createTextNode(word);
      let hasFeedback = false;
      if(this.activemetric === 'fillers') {
        hasFeedback = this.results.details.fillers.transcriptHighlightLayers.some(item => item.segments.some(segment =>index >= (segment.startIndex?segment.startIndex:-1) && index <= (segment.endIndex?segment.endIndex:-1)));
      }
      let hasPaceSlow = false;
      let hasPaceFast = false;
      let hasPaceHigh = false;
      let hasPaceLow = false;
      if(this.activemetric === 'pace') {
        hasPaceSlow = this.results.details.pace.transcriptHighlightLayers.some(item => item.title === "Too Slow" && item.segments.some(segment =>index >= (segment.startIndex?segment.startIndex:-1) && index <= (segment.endIndex?segment.endIndex:-1)));
        hasPaceFast = this.results.details.pace.transcriptHighlightLayers.some(item => item.title === "Too Fast" && item.segments.some(segment =>index >= (segment.startIndex?segment.startIndex:-1) && index <= (segment.endIndex?segment.endIndex:-1)));
        hasPaceHigh = this.results.details.pace.transcriptHighlightLayers.some(item => item.title === "High Variation" && item.segments.some(segment =>index >= (segment.startIndex?segment.startIndex:-1) && index <= (segment.endIndex?segment.endIndex:-1)));
        hasPaceLow = this.results.details.pace.transcriptHighlightLayers.some(item => item.title === "Low Variation" && item.segments.some(segment =>index >= (segment.startIndex?segment.startIndex:-1) && index <= (segment.endIndex?segment.endIndex:-1)));
      }
      
      // Add textNode
      if (index > 0) {
        appendSlicedText(wordArray, transcriptTextEl, textStart, index);
        textStart = index;
      }

      let spanEl;
      if (hasFeedback) {
        spanEl = this.spanElTemplate.cloneNode(true) as HTMLElement;
        spanEl.className = "filler-bold";
      }

      if(hasPaceSlow) {
        if(spanEl) {
          spanEl.className += " pace-slow";
        } else {
          spanEl = this.spanElTemplate.cloneNode(true) as HTMLElement;
          spanEl.className = "pace-slow";
        }
      }

      if(hasPaceFast) {
        if(spanEl) {
          spanEl.className += " pace-fast";
        } else {
          spanEl = this.spanElTemplate.cloneNode(true) as HTMLElement;
          spanEl.className = "pace-fast";
        }
      }

      if(hasPaceLow) {
        if(spanEl) {
          spanEl.className += " pace-low";
        } else {
          spanEl = this.spanElTemplate.cloneNode(true) as HTMLElement;
          spanEl.className = "pace-low";
        }
      } 
      
      if(hasPaceHigh) {
        if(spanEl) {
          spanEl.className += " pace-high";
        } else {
          spanEl = this.spanElTemplate.cloneNode(true) as HTMLElement;
          spanEl.className = "pace-high";
        }
      }

      if (spanEl) {
        spanEl.appendChild(wordNode);
        transcriptTextEl.appendChild(spanEl);
        textStart++;
      }
    }
    appendSlicedText(wordArray, transcriptTextEl, textStart, index);
  }
}
